import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import RemoveCircleOutlineSharpIcon from '@mui/icons-material/RemoveCircleOutlineSharp';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import palette from '../../../styles/palette';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { genderPercentage } from '../../../utils/abdmUtils';

export default function ZipcodeInfo({
  demographics,
  zipcodeTitle,
  isAdded,
  onToggle,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const styles = {
    panel: {
      marginLeft: '1em',
      padding: '1.25em',
      backgroundColor: palette.white,
      border: `1px solid ${palette.soft_blue}`,
      borderRadius: '8px',
    },
    icon: {
      color: palette.black,
      transform: 'scale(1.6)',
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    // divider: {
    //   margingLeft: '1em',
    //   paddingLeft: '1em',
    //   paddingRight: '1em',
    //   borderLeft: `1px solid ${palette.gt_grey_light_5}`,
    // },
  };
  const renderCell = (label, value) => (
    <Stack direction="row" spacing={1}>
      <Typography variant="body2">{label}:</Typography>
      <Typography variant="body2" sx={{ fontWeight: '600' }}>
        {value}
      </Typography>
    </Stack>
  );

  const zipcode = renderCell('Zip Code', zipcodeTitle);
  // const avgIncome = renderCell(
  //   'Avg. Icome',
  //   demographics ? demographics.avg_hhi_formatted : '$0',
  // );
  // const avgAge = renderCell(
  //   'Avg. Age',
  //   demographics ? demographics.avg_age : '0',
  // );
  const cost = renderCell(
    'Cost',
    demographics ? demographics.price_formatted : '$0',
  );
  const totalHouseHolds = renderCell(
    'Addresses',
    demographics ? demographics.total_households : '0',
  );

  // const [femaleAudience, maleAudience, otherAudience] = demographics
  //   ? genderPercentage(
  //       demographics.gender_female,
  //       demographics.gender_male,
  //       demographics.gender_other,
  //     )
  //   : [0, 0, 0];
  // const female = renderCell('Female', femaleAudience);
  // const male = renderCell('Male', maleAudience);
  // const other = renderCell('Other', otherAudience);

  return (
    <Stack direction="row" spacing={1} sx={styles.panel}>
      <div>
        {zipcode}
        {totalHouseHolds}
        {/* {avgIncome}
        {avgAge} */}
        {cost}
      </div>
      {/* <div style={styles.divider}>
        {female}
        {male}
        {other}
      </div> */}
      <div>
        {isMobile ? (
          <Stack direction="column" sx={styles.center}>
            <IconButton onClick={onToggle}>
              {isAdded ? (
                <RemoveCircleOutlineSharpIcon sx={styles.icon} />
              ) : (
                <AddCircleSharpIcon sx={styles.icon} />
              )}
            </IconButton>
            <Typography variant="body2" gutterBottom>
              {isAdded ? 'Remove' : 'Add'}
            </Typography>
          </Stack>
        ) : (
          <div></div>
        )}
      </div>
    </Stack>
  );
}
